import { Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { Component } from '@angular/core';
import { AccessControlGuard } from './guards/access-control.guard';

// Empty component for handling unknown routes (including MSAL redirect)
@Component({
  selector: 'app-redirect-handler',
  template: '',
  standalone: true,
})
export class RedirectHandlerComponent {}

// Conditional route configuration based on sessionStorage
export const routes: Routes = [
  {
    path: 'bulkentry',
    loadChildren: () =>
      import('./pages/sparci.routes').then((m) => m.sparci_routes),
    canActivate: [AccessControlGuard, MsalGuard], // AccessControlGuard runs BEFORE MsalGuard
  },
  {
    path: 'customreports',
    loadChildren: () =>
      import('./features/custom-report/custom-report.routes').then(
        (m) => m.CUSTOM_REPORT_ROUTES,
      ),
    canActivate: [AccessControlGuard, MsalGuard], // AccessControlGuard runs BEFORE MsalGuard
  },
  {
    // Route for access denied cases (no guards, always accessible)
    path: 'access-denied',
    component: RedirectHandlerComponent,
  },
  {
    // Catch-all route for MSAL redirects and unknown routes
    path: '**',
    component: RedirectHandlerComponent,
  },
];
